<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()">
        <ng-container>
            <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Support Ticket</h2>
            <mat-dialog-content>
                <div class="row" *ngIf="_Global.hasGUIPermission('Support')">
                    <div class="col-md-12">
                        <app-division-selector multiple name="Divisions" [allOption]="true"
                                               placeholder="Divisions"
                                               [(ngModel)]="Divisions"></app-division-selector>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <app-dropdown-option model="SupportTicket" discriminator="Type" name="Type"
                                             placeholder="Type" required
                                             [(ngModel)]="Copy.Type"></app-dropdown-option>
                    </div>
                </div>
                <div class="row" *ngIf="_Global.hasGUIPermission('Support') && Copy.Id">
                    <div class="col-md-12">
                        <app-dropdown-option model="SupportTicket" discriminator="Status" name="Status"
                                             placeholder="Status" required
                                             [(ngModel)]="Copy.Status"></app-dropdown-option>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                          <mat-label>Title</mat-label>
                            <input matInput name="Title" [(ngModel)]="Copy.Subject">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row" *ngIf="!Copy.Id">
                    <div class="col-12">
                        <mat-form-field>
                          <mat-label>Description</mat-label>
                            <textarea style="width: 300px;" rows="6" matInput name="Description"
                                      [(ngModel)]="Copy.SupportMessages[0].Message"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </mat-dialog-content>
            <mat-dialog-actions>
            <span *ngIf="Copy.Id" class="mat-button mat-raised-button mat-warn" appConfirmDialog
                  (confirm)="remove(Copy, true)">Delete</span>
                <div class="fill-remaining-space"></div>
                <button mat-button mat-raised-button [mat-dialog-close]="true">Close</button>
                <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
            </mat-dialog-actions>
        </ng-container>
    </form>
</ng-template>
